import { render } from "./sms.vue?vue&type=template&id=71fba0f5"
import script from "./sms.vue?vue&type=script&lang=js"
export * from "./sms.vue?vue&type=script&lang=js"

import "./sms.vue?vue&type=style&index=0&id=71fba0f5&lang=css"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__